import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'

interface Props {}

export const DemolitionTechnicalFormB3: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<any>
  return (
    <FormSectionTwoColumns
      title="B.3 Úpravy terénu a řešení vegetace po odstranění stavby"
      subtitle="Terénní úpravy po odstranění stavby, vegetační prvky a biotechnická opatření."
      sectionKey="b3.terrainModifications"
    >
      <>
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b3.terrainModifications.hasTerrainModifications"
            label="Terénní úpravy po odstranění stavby"
          />
        </div>
        {formik?.values.b3?.terrainModifications?.hasTerrainModifications && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b3.terrainModifications.terrainModifications"
              label=""
              component={RichTextInput}
              aiHint={
                'Terénní úpravy po odstranění stavby'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b3.terrainModifications.hasVegetationElements"
            label="Vegetační prvky"
          />
        </div>
        {formik?.values.b3?.terrainModifications?.hasVegetationElements && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b3.terrainModifications.vegetationElements"
              label=""
              component={RichTextInput}
              aiHint={
                'Vegetační prvky po odstranění stavby'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b3.terrainModifications.hasBiotechnicalMeasures"
            label="Biotechnická opatření"
          />
        </div>
        {formik?.values.b3?.terrainModifications?.hasBiotechnicalMeasures && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b3.terrainModifications.biotechnicalMeasures"
              label=""
              component={RichTextInput}
              aiHint={
                'Biotechnická opatření po odstranění stavby'
              }
            />
          </div>
        )}
      </>
    </FormSectionTwoColumns>
  )
}
